module.exports = __webpack_public_path__ + "static/media/logo_full.623d5050.png";